var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Monitor'),_c('Events'),_c('DeviceStatus'),(_vm.selectBuildId !='')?_c('FloorDetection'):_c('SecurityScore'),_c('Inspection'),_c('StaffDensity')],1)}
var staticRenderFns = []

export { render, staticRenderFns }